export default __webpack_public_path__ + "static/media/hold-me-pepe.97065544.jpeg";